import React from 'react';
import { Button } from 'react-bootstrap';
import { FaTrashAlt } from "react-icons/fa";

/**
 * リセットボタンコンポーネント用のPropsです。
 * @interface ResetButtonProps
 */
interface ResetButtonProps {
  /**
   * ボタンクリック時の動作を設定する関数
   * @memberof ResetButtonProps
   */
  onClick: () => void;
}

/**
 * リセットボタンコンポーネントです。
 * @param {function} props.onClick - ボタンクリック時に呼ばれるコールバック関数
 * @returns {JSX.Element} - リセットボタンのJSX要素
 */
const ResetButton: React.FC<ResetButtonProps> = ({ onClick }) => {
  return (
    <Button
      variant="outline-danger"
      size="sm"
      onClick={onClick}
    >
      <FaTrashAlt />
      <span className="ms-1">入力クリア</span>
    </Button>
  );
}

export default ResetButton;